export function NotFound() {
  return (
    <main className="page">
      <h1>Page not found</h1>
      <p>
        <a href="/">Go to the start</a>
      </p>
    </main>
  );
}
